/**
 * Shared keys used by every root component of the library.
 * Introduced by KB-160855 to surface authentication failures propagated
 * through the injected `FintechTokenProvider`.
 */
const CommonI18n_enUs = {
  authError: {
    title: 'Authentication could not be completed',
    providerNotConfigured: 'FintechTokenProvider is not configured: call setTokenProvider before starting the component.',
    customerTokenUnavailable: 'Unable to obtain the authentication token!',
    adminTokenUnavailable: 'Unable to obtain the administrator token!',
  },
};

export default CommonI18n_enUs;
